import { MapTo } from '@adobe/aem-react-editable-components';
import ConfirmationPageHero, { ConfirmationPageHeroEditConfig } from './ConfirmationPageHero';

export default MapTo(
    'cob-corp-acquisition/components/creditonebank/confirmation-page-hero',
)(ConfirmationPageHero, ConfirmationPageHeroEditConfig);